/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ShiftBidStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
}